/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TournamentGroupList = {
    type: 'array',
    contains: {
        type: 'TournamentGroup',
    },
} as const;
